import React, { useEffect, useState } from 'react'
import { useBnsGuangGaoFaBuUpdateQuery } from '../../store/ReactWebSiteApi';
import { Descriptions, Space, Spin } from 'antd';
import DocTitle from '../../cpn/DocTitle';
import PublishEdit from './PublishEdit';
import PublishReport from './PublishReport';
import PackageCheck from '../../promote/package/PackageCheck';
function PublishDesc(props) {
    const [info,setInfo] = useState({
        ebn_team_num:'',
    })
    const {data,isSuccess} = useBnsGuangGaoFaBuUpdateQuery({bggfb_id:props.bggfb_id},{skip:!props.bggfb_id})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data);                        
                setInfo({
                    bggfb_content:data.Result.bggfb_content,
                    bggfb_dept_id:data.Result.bggfb_dept_id,        
                    bggfb_dept_name:data.Result.bggfb_dept_name,        
                    bggfb_bg_name:data.Result.bggfb_bg_name,        
                    bggfb_meijie_name:data.Result.bggfb_meijie_name,  
                    bggfb_ctime:data.Result.bggfb_ctime,                                       
                    bggfb_cname:data.Result.bggfb_cname,                                       
                    bggfb_jihuariqi:data.Result.bggfb_jihuariqi,                                                
                    bggfb_name:data.Result.bggfb_name,                                                
                    bggfb_fuzhuren_name:data.Result.bggfb_fuzhuren_name,                                                
                    bggfb_huibao_ctime:data.Result.bggfb_huibao_ctime,                                                
                    bggfb_bbz_id:data.Result.bggfb_bbz_id,                                                
                    bggfb_bbz_name:data.Result.bggfb_bbz_name,                                                
                    bggfb_huibao_content:data.Result.bggfb_huibao_content,                                                
                })
                // console.log(array);
                
            }
        }
    },[data, isSuccess])

    const items = [
        {
            key:'bggfb_meijie_name',
            label:'发布平台',
            children:info.bggfb_meijie_name,
            contentStyle:{fontSize:"18px"},
        },
        {
            key:'bggfb_bg_name',
            label:'产品',
            children:<>{info.bggfb_bg_name}</>,
            labelStyle:{width:'120px'},
            contentStyle:{fontSize:"18px"}
        },      
        {
            key:'bggfb_bbz_name',
            label:'广告设计',
            children:<PackageCheck bbz_name={info.bggfb_bbz_name} bbz_id={info.bggfb_bbz_id}/>,
            labelStyle:{width:'120px'},
            contentStyle:{fontSize:"18px"}
        },      
        {
            key:'bggfb_jihuariqi',
            label:'任务日期',
            children:info.bggfb_jihuariqi,
            contentStyle:{fontSize:"18px"},
        },
        {
            key:'bggfb_fuzhuren_name',
            label:'负责人',
            children: info.bggfb_fuzhuren_name,
            contentStyle:{fontSize:"18px"},
        },
        {
            key:'bggfb_state',
            label:'状态',
            children: info.bggfb_state==='1'?<>已实现</>:<>待实现</>,
            contentStyle:{fontSize:"18px"},
            span:2
        },
        {
            key:'bggfb_name',
            label:'任务名称',
            children:info.bggfb_name,
            contentStyle:{fontSize:"18px"},
            span:3
        },
       
        {
            key:'bggfb_content',
            label:'任务备注',
            children:<div  dangerouslySetInnerHTML={{__html:info.bggfb_content}}></div>,
            contentStyle:{fontSize:"18px"},
            span:3
        },
        {
            key:'7',
            label:'发布日期',
            children:info.bggfb_huibao_ctime,
            contentStyle:{fontSize:"18px"},
            span:3
        },
        {
            key:'7',
            label:'发布说明',
            children:<div  dangerouslySetInnerHTML={{__html:info.bggfb_huibao_content}}></div>,
            contentStyle:{fontSize:"18px"},
            span:3
        },
        {
            key:'bggfb_dept_name',
            label:'部门',
            children:<>{info.bggfb_dept_name}</>,
            labelStyle:{width:'120px'},
            contentStyle:{fontSize:"18px"}
        },
        {
            key:'bggfb_ctime',
            label:'新增时间',
            children:info.bggfb_cname+info.bggfb_ctime,
            contentStyle:{fontSize:"18px"},
        },
        {
            key:'action',
            label:'操作',
            children:   <Space>
                            <PublishEdit
                                bggfb_id={props.bggfb_id}
                            />
                            <PublishReport
                                bggfb_id={props.bggfb_id}
                            />
                        </Space>,
        },
    ]
    return (
        <>
            {info.bggfb_ctime ? <div 
                                    style={{border:'2px solid #eee',margin:"10px",padding:'20px'}}
                                >
                                   <DocTitle
                                        name='广告发布任务说明书'
                                        num={props.bggfb_id}                        
                                    />                                    
                                    <Descriptions
                                        items={items}
                                        bordered
                                    />
                                </div>:  <Spin  size='large' />}
        </> 
    )
}

export default PublishDesc